export const breakpoints = [
  { w: 567, label: 'xs' },
  { w: 768, label: 'sm' },
  { w: 992, label: 'md' },
  { w: 1200, label: 'lg' },
  { w: 9999, label: 'xl' },
];

export const DEFAULT_RESPONSIVE_SIZE = 'lg';
export const defaultItemResponsive = [
  {
    label: DEFAULT_RESPONSIVE_SIZE,
    info: {
      w: 24,
      h: 3,
    },
  },
];
